export const navMenuWidth = 240;